import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';
//列表
export async function getItemList(params) {
    return post(oaserver+'/dict/item/getItemList', params, true);
}
//树
export async function getItemTypeList(params) {
    return post(oaserver+'/dict/item/getItemTypeList', params, true);
}
//新增树
export async function addItemType(params) {
    return post(oaserver+'/dict/item/addItemType', params, true);
}
//新增列表
export async function addItem(params) {
    return post(oaserver+'/dict/item/addItem', params, true);
}
//编辑列表
export async function editItem(params) {
    return post(oaserver+'/dict/item/editItem', params, true);
}
//单位组列表
export async function getUnitGroupList(params) {
    return post(oaserver+'/dict/unitGroup/getUnitGroupList', params, true);
}